import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const SumDifTask = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default SumDifTask
